import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { referansAPI } from '../api/api';
import './Referanslar.css';

const Referanslar = () => {
  const [referanslar, setReferanslar] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    loadReferanslar();
  }, []);

  const loadReferanslar = async () => {
    try {
      setLoading(true);
      const data = await referansAPI.getAll();
      setReferanslar(data.filter(r => r.isActive !== false));
    } catch (error) {
      console.error('Referanslar yüklenirken hata:', error);
      alert('Referanslar yüklenirken hata oluştu: ' + (error.response?.data?.message || error.message));
    } finally {
      setLoading(false);
    }
  };

  const handleReferansClick = (referansId) => {
    navigate(`/referans/${referansId}/case-files`);
  };

  if (loading) {
    return <div className="loading">Yükleniyor...</div>;
  }

  return (
    <div className="referanslar-container">
      <div className="page-header">
        <h1>Referanslar</h1>
      </div>
      <div className="referanslar-grid">
        {referanslar.length === 0 ? (
          <div className="no-data">Henüz referans bulunmamaktadır.</div>
        ) : (
          referanslar.map((referans) => (
            <div
              key={referans.id}
              className="referans-card"
              onClick={() => handleReferansClick(referans.id)}
            >
              <div className="referans-icon">👤</div>
              <h3>{referans.name}</h3>
              {referans.description && (
                <p className="referans-description">{referans.description}</p>
              )}
              <div className="referans-stats">
                <span className="referans-count-badge">
                  📁 {referans.activeCaseFileCount || referans.ActiveCaseFileCount || 0} Aktif Dosya
                </span>
              </div>
              <div className="referans-footer">
                <span className="referans-badge">Dosyaları Görüntüle →</span>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default Referanslar;

